import { useQuery } from '@tanstack/react-query'

import type {
  CatalogueDashboardResponse,
  ProjectsDashboardResponse,
  SalesDashboardResponse,
  SystemDashboardResponse,
} from '@brickup/shared/dto'
import { apiClient } from './client'
import { GLANCE } from './glance'

const BASE = '/internal/dashboard'

const dashboardQuery = <T>(area: string) => ({
  queryKey: ['staff-dashboard', area],
  queryFn: async (): Promise<T> =>
    (await apiClient.get<T>(`${BASE}/${area}`)).data,
  ...GLANCE,
})

export const useSalesDashboard = () =>
  useQuery(dashboardQuery<SalesDashboardResponse>('sales'))

export const useProjectsDashboard = () =>
  useQuery(dashboardQuery<ProjectsDashboardResponse>('projects'))

export const useCatalogueDashboard = () =>
  useQuery(dashboardQuery<CatalogueDashboardResponse>('catalogue'))

export const useSystemDashboard = () =>
  useQuery(dashboardQuery<SystemDashboardResponse>('system'))
